import { Box, Button, paletteColors } from '@evaneos/b2b-ui';

import { Logo } from '../../../design-system/SVG/Logo';
import { VisuallyHidden } from '../../../shared/components/VisuallyHidden';
import { homeBasename, LOGIN_URL } from '../constants/urls';

export const TravelSuiteHeader = () => (
    <Box
        component="header"
        sx={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
            bgcolor: paletteColors.neutral[0],
            borderBottom: `1px solid ${paletteColors.neutral[200]}`,
            px: { xs: 2, md: 8 },
            py: 2,
        }}
    >
        <Box
            sx={{
                maxWidth: '1200px',
                mx: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Box
                component="a"
                href={homeBasename}
                sx={{ textDecoration: 'none', '&:hover': { opacity: 0.8 }, display: 'flex' }}
            >
                <Logo />
                <VisuallyHidden>Evaneos Travel Suite</VisuallyHidden>
            </Box>
            <Button href={LOGIN_URL} variant="contained">
                Log in
            </Button>
        </Box>
    </Box>
);
